import React, { useEffect, useState } from "react";
import Tables from "../../Controller/Table";
import { getAllProducts } from "../../services/api";
import SideMenu from "../../containers/sidemenu";
import Navbar from "../../containers/navbar";
import ImageLoader from "../../containers/loader";
import Confirm from "../../containers/Confirm";
import { useHistory } from "react-router-dom";
import AddProducts from "./AddProductModal";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [progress, setProgress] = useState(false);
  let heading = ["Id", "Items"];
  let accessors = ["id", "name"];
  const history = useHistory();

  let allProducts = async () => {
    try {
      setProgress(true);
      let response = await getAllProducts(1, 100000);
      if (response.status === 200) {
        setProducts(response.data.products.items);
      } else {
        console.log(response.statusMessage);
      }
      setProgress(false);
    } catch (error) {
      console.log(error);
      setProgress(false);
    }
  };

  function AddProduct() {
    return history.push("/setting/products/add");
  }

  useEffect(() => {
    allProducts();
  }, [products.length]);

  return (
    <div>
      <SideMenu />
      <div class='dashboard complaints-section'>
        <Navbar />
        <section id='contents'>
          <section class='statis text-center'>
            <div class='container-fluid'>
              <div class='row'></div>
              <div class='row user_section'>
                <div className='p-0'>
                  <div class='col-md-3 text-left p-0 ps-5'>
                    <button
                      onClick={AddProduct}
                      class='btn btn-primary add-btn mx-0'
                    >
                      ADD
                    </button>
                  </div>
                </div>
                <div class='col-md-12 px-5'>
                  <Tables
                    heading={heading}
                    itemsPerPage={10}
                    accessors={accessors}
                    data={products}
                    fetching={progress}
                    navlink={"/setting/products/"}
                    customComponent={AddProducts}
                    onPopupClose={() => {
                      allProducts();
                    }}
                  />
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
};

export default Products;
